import React, { useEffect } from "react";
import { AlertTriangle } from "lucide-react";

export function ConfirmDialog({ open, title, message, confirmLabel = "Lanjutkan", cancelLabel = "Batal", onConfirm, onCancel, testid = "confirm-dialog" }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && onCancel();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel]);
  if (!open) return null;
  return (
    <div className="dialog-backdrop" onClick={onCancel} data-testid={testid}>
      <div className="dialog-panel" role="alertdialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-50 text-amber-600"><AlertTriangle size={18} /></span>
        <h2 className="mt-4 text-base font-bold text-slate-900" data-testid={`${testid}-title`}>{title}</h2>
        <div className="mt-1.5 text-sm text-slate-600" data-testid={`${testid}-message`}>{message}</div>
        <div className="mt-6 flex justify-end gap-2">
          <button onClick={onCancel} className="btn-soft rounded-xl px-4 py-2 text-xs font-bold" data-testid={`${testid}-cancel`}>{cancelLabel}</button>
          <button onClick={onConfirm} autoFocus className="btn-primary rounded-xl px-4 py-2 text-xs font-bold" data-testid={`${testid}-confirm`}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
